import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { Environment } from 'src/environments/environment.model';

export interface ConceptReference {
  id: number;
  conceptId: string;
  name: string;
}

export interface ChainPartnerReference {
  id: number;
  chainPartnerId: string;
  name: string;
  type: string;
}

@Injectable({
  providedIn: 'root',
})
export class DataExchangeService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);
  private readonly baseUrl = `${this.env.APIM_BASE_URL}/arable-service`;

  private readonly concepts$ = this.http
    .get<ConceptReference[]>(`${this.baseUrl}/concept`)
    .pipe(shareReplay({ bufferSize: 1, refCount: true }));
  private readonly buyerChainPartners$ = this.http
    .get<ChainPartnerReference[]>(`${this.baseUrl}/chainpartner`, { params: { type: 'Buyer' } })
    .pipe(shareReplay({ bufferSize: 1, refCount: true }));

  getConcepts(): Observable<ConceptReference[]> {
    return this.concepts$;
  }

  getBuyerChainPartners(): Observable<ChainPartnerReference[]> {
    return this.buyerChainPartners$;
  }
}
